module.exports = __webpack_public_path__ + "static/img/icon_94_gonggaoadd.e4bda43e.png";